import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PageHero from "../components/child/PageHero";
import TemplateLayer from "../components/TemplateLayer";

const TemplateList = () => (
  <MasterLayout>
    <PageHero
      title="Templates"
      subtitle="Reusable message and media templates for faster sending."
      badge={{ icon: "mdi:file-document-edit-outline", label: "Library" }}
    />
    <TemplateLayer />
  </MasterLayout>
);

export default TemplateList;
